import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { LogisticsOrderDetailsService } from '../../api/services/logisticsOrderDetailsService';
import { IGetOrderDetailsResponse } from '../../types/api/response/logisticsorderdetailsresponse';
import { PAGE_NOT_FOUND_ROUTE } from '../../constants/routes';
import { Box, Card, Typography } from '@mui/material';
import { LogisticsOrderDetailsDatagridItems } from '../../components/DataGrid/LogisticsOrderDetailsItems/LogisticsOrderDetailsDatagrid';
import { LogisticsOrderDetailsDatagridAdditionalCharge } from '../../components/DataGrid/LogisticsOrderDetailsAdditionalCharges/LogisticsOrderDetailsDatagrid';

export const LogisticsOrderDetails = () => {
  const { orderNumber } = useParams();
  const navigate = useNavigate();
  const [orderDetails, setOrderDetails] = useState<IGetOrderDetailsResponse | null>(null);

  const retrieveOrderDetails = async (orderNumber: string | undefined) => {
    if (orderNumber) {
      const details = await LogisticsOrderDetailsService.getOrderDetails(orderNumber);
      setOrderDetails(details);
    } else {
      navigate(PAGE_NOT_FOUND_ROUTE);
    }
  };

  useEffect(() => {
    retrieveOrderDetails(orderNumber);
  }, [orderNumber]);

  return (
    <>
      {orderDetails ? (
        <div>
          <Card variant="outlined">
            <Box sx={{ display: 'flex', flexDirection: 'column', p: 2 }}>
              {/* Order number and total */}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Typography variant="subtitle1" fontWeight={600}>
                  {orderDetails?.order_no}&nbsp;(
                  {orderDetails?.item_count}{' '}
                  {Number(orderDetails?.item_count) > 1 ? 'items' : 'item'})
                </Typography>
                <Typography variant="subtitle1" color="primary" fontWeight={600}>
                  $ {orderDetails?.order_total}
                </Typography>
              </Box>

              {/* Credit used */}
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 0.5 }}>
                <Typography variant="caption">
                  Credit used (SuperWallet): $ {orderDetails?.credit_used}
                </Typography>
              </Box>

              {/* Amount to pay */}
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Typography variant="subtitle2" color="success.main" fontWeight={600}>
                  Amount to Pay: $ {orderDetails?.order_total}
                </Typography>
              </Box>
            </Box>
          </Card>

          <LogisticsOrderDetailsDatagridItems data={orderDetails.items} />
          <LogisticsOrderDetailsDatagridAdditionalCharge data={orderDetails.additional_charges} />
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
